<!--  通用的页面-->
<template>
  <div class="page" :class="{ padding: remarkInfoList.length }">
    <HeaderTop
      ref="headrTop"
      :subNavList="remarkInfoList"
      :currentExamYearInfo="currentExamYearInfo"
      @showYearBox="showYearBox"
      @sendCatalog="receiveCatalog"
    />
    <!-- 广告位，tab推荐-->
    <template v-if="pageModal === 0">
      <div v-show="selectedSubNav === 0">
        <!-- 轮播 -->
        <Banner :examYear="advertCodeInfo.year" :bannerList="bannerList" />
        <!-- 金刚区域 -->
        <CustomButton :examYear="advertCodeInfo.year" :iconLists="iconLists" />
        <!-- 首页胶囊区 -->
        <Advertisement
          :examYear="advertCodeInfo.year"
          :advertLists="advertLists"
          :advertisement="advertisement"
        />
        <!-- 直播公开课 -->
        <RecentLiveCourse
          ref="liveCours"
          :classCode="advertCodeInfo.code"
          :advertCodeInfo="advertCodeInfo"
          @openLive="openLive"
          @showRemindBox="showRemindBox"
          :examYear="advertCodeInfo.year"
        />
        <!-- 热销课程榜单 -->
        <HotSaleCourse
          :hotSaleId="advertCodeInfo.hotSaleCourseId"
          :examYear="advertCodeInfo.year"
        />
        <!-- 考研咨询专区 -->
        <PostgraduateChat
          v-show="postgraduateChatList.length"
          :postgraduateChatList="postgraduateChatList"
          :examYear="advertCodeInfo.year"
        />
        <!-- 优惠券抢购专区 -->
        <HomeCoupon :advertCodeInfo="advertCodeInfo" :couponadvertList="couponadvertList" />
        <!-- 精选课程 -->
        <HotCourse ref="hotCourse" :examYear="advertCodeInfo.year" />
        <!-- 底部广告位 -->
        <Bottomadvert
          :examYear="advertCodeInfo.year"
          :bottomadvertList="bottomadvertList"
          :bottomAreaHeight="bottomAreaHeight"
        />
        <!-- 悬浮聊天 -->
        <Chat />
        <!-- 首页弹窗 -->
        <HomePop
          v-if="isPopBox"
          :examYear="advertCodeInfo.year"
          @closePopBox="closePopBox"
          :popupData="popupData"
        />
      </div>
      <div v-show="selectedSubNav !== 0">
        <RecommendContent :remarkInfoList="remarkInfoList" :selectedSubNav="selectedSubNav" />
      </div>
    </template>
    <!-- tab推荐 -->
    <template v-if="pageModal === 1">
      <RecommendContent :remarkInfoList="remarkInfoList" :selectedSubNav="selectedSubNav" />
    </template>
    <!-- 仅有一个推荐位ID -->
    <template v-if="pageModal === 2">
      <div class="productList"><ProductList :recomendId="remarkInfo.recommendId" /></div>
    </template>
    <!-- 选择考季 -->
    <SelectType
      v-if="isYearTabBox"
      :currentExamYearInfo="currentExamYearInfo"
      :newData="dictionaryData"
      @closeYearBox="closeYearBox"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { reqTypeList, reqAdvertPlaying } from '@/api/home';
import iconList from '@/utils/iconsTypes';
import { advertCode } from '@/utils/advertCodeList';
import MultipleLiveCourse from '@/components/multipleLiveCourse/index.vue';
import Foot from '@/components/foot/privacy.vue';
import Bottomadvert from './components/bottomadvert.vue';
import HeaderTop from './components/appHeaderTop.vue';
import SelectType from './components/selectTypes.vue';
import Banner from './components/bannerVant.vue';
import CustomButton from './components/customButton.vue';
import HomeAdvert from './components/homeAdvert.vue';
import RecentLiveCourse from './components/recentLiveCourse.vue';
import HotCourse from './components/hotCourse.vue';
import RemindBox from '@/components/remindBox/index.vue';
import HomePop from './components/homePop.vue';
import GoToAppVue from '../../components/commonComponents/goToApp.vue';
import Advertisement from './components/advertisement.vue';
import Chat from './components/chat.vue';
import PostgraduateChat from './components/postgraduateChat.vue';
import HomeCoupon from './components/homeCoupon.vue';
import HotSaleCourse from './components/hotSaleCourse.vue';
import RecommendContent from './components/recommendContent.vue';
import ProductList from './components/productList.vue';
import { data } from 'autoprefixer';

export default {
  components: {
    HeaderTop,
    SelectType,
    Banner,
    CustomButton,
    HomeAdvert,
    RecentLiveCourse,
    HotCourse,
    RemindBox,
    RecommendContent,
    HomePop,
    GoToAppVue,
    Advertisement,
    MultipleLiveCourse,
    Chat,
    PostgraduateChat,
    Foot,
    Bottomadvert,
    HomeCoupon,
    HotSaleCourse,
    ProductList,
  },
  props: {
    currentCode: {
      type: Number,
      default: '',
    },
  },
  data() {
    return {
      defaultImgUlr: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/icon-22.png',
      code: '',
      pageModal: 0,
      dictionaryData: [],
      currentExamYearInfo: {},
      remarkInfo: {},
      remarkInfoList: [],
      advertCodeInfo: {},
      isYearTabBox: false,
      bannerList: [], // 轮播图数据
      iconLists: [], // 金刚区
      advertLists: [], // 胶囊区
      advertisement: {}, // 长图广告未
      postgraduateChatList: [], // 考研咨询专区
      bottomadvertList: [], // 底部广告位
      couponadvertList: [], // 优惠券广告位
      popupData: {}, // 弹窗
      isRemindBox: false, // 开播提醒弹框
      videoList: [],
      openCourseId: '',
      showLive: false,
      selectedSubNav: 0, // 当前选中的类目
      courseTabDetails: {}, // tab詳情
      isCourseCard: false,
      bottomAreaHeight: 0,
      isPopBox: false,
    };
  },
  computed: {},
  watch: {
    currentCode(code) {
      this.code = code;
      this.getTypeList();
    },
  },
  methods: {
    // 获取基础字段
    async getTypeList() {
      const { code, data } = await reqTypeList('HOME_EXAM_CONFIG_H5');
      if (!data?.length) return;
      data.forEach((element) => {
        Object.assign(element, {
          imgUrl: iconList.find((item) => item.code == element.code)?.imgUrl || this.defaultImgUlr,
        });
      });
      this.dictionaryData = data;
      this.getAdInfo(this.code);
    },
    // 已登录时，需要定位上次选择的考纪
    async getAdInfo(code) {
      const findRes = this.dictionaryData.find((ele) => ele.code == code) || data[0];

      const remark = JSON.parse(findRes?.remark);
      this.currentExamYearInfo = findRes;
      this.advertCodeInfo = advertCode[code] || {};
      console.log(findRes, this.advertCodeInfo, 88);
      if (!Array.isArray(remark)) {
        // 展示课程列表
        this.remarkInfo = remark;
        this.pageModal = 2;
      } else {
        // 展示专业tab
        this.remarkInfoList = remark;
        if (this.advertCodeInfo?.code) {
          // 有广告位
          this.remarkInfoList.unshift({ id: 0, name: '精选' });
        } else {
          //无广告位
          this.pageModal = 1;
          this.selectedSubNav = 0;
        }
      }
      const {
        bannerCode,
        customButtonCode,
        bigAdvertCode,
        smallAdvertCode,
        homePopupCode,
        postgraduateChatCode,
        bottomFloatCode,
        limtiCouponCode,
      } = this.advertCodeInfo;

      this.getAd(bannerCode).then((data) => {
        this.bannerList = data || [];
      });
      this.getAd(customButtonCode).then((data) => {
        this.iconLists = data || [];
      });
      this.getAd(smallAdvertCode).then((data) => {
        this.advertLists = data?.slice(0, 2) || [];
      });
      this.getAd(bigAdvertCode).then((data) => {
        this.advertisement = data?.[0] || {};
      });
      this.getAd(homePopupCode).then((data) => {
        this.popupData = data?.[0] || {};
        if (this.popupData?.id) {
          this.isPopBox = true;
        }
      });
      this.getAd(postgraduateChatCode).then((data) => {
        this.postgraduateChatCode = data || [];
      });
      this.getAd(bottomFloatCode).then((data) => {
        this.bottomadvertList = data || [];
      });
      this.getAd(limtiCouponCode).then((data) => {
        this.couponadvertList = data || [];
      });
    },
    // 请求广告位
    async getAd(adCode) {
      if (!adCode) return;
      const res = await reqAdvertPlaying([adCode]);
      const findRes = res.data?.find(
        (item) => item.adCode === adCode,
      )?.advertisingContentWebInfoRespVOS;
      return findRes;
    },
    // 显示选择年份弹框
    showYearBox() {
      this.isYearTabBox = true;
    },
    // 关闭选择年份弹框
    closeYearBox(code) {
      console.log('code', code);
      this.code = code;
      this.clearData();
      this.getAdInfo(code);
      this.isYearTabBox = false;
    },
    clearData() {
      this.bannerList = [];
      this.iconLists = [];
      this.advertLists = [];
      this.popupData = {};
      this.advertisement = {};
      this.postgraduateChatList = [];
      this.bottomadvertList = [];
      this.couponadvertList = [];
      this.selectedSubNav = 0;
      this.remarkInfoList = [];
      this.remarkInfo = {};
      this.pageModal = 0;
      this.$refs.headrTop.selected = 0;
    },
    // 切换tab回调
    receiveCatalog(data) {
      console.log(data, this.remarkInfoList);
      const { index } = data;
      this.selectedSubNav = index;
      if (index === 0) {
        this.getAdInfo(this.code);
      }
    },
    openLive(data) {
      this.videoList = data.videoList;
      this.openCourseId = data.openCourseRecordId;
      this.showLive = true;
    },
    showRemindBox() {
      // 打开开播提醒
      this.isRemindBox = true;
    },
    closePopBox() {
      this.isPopBox = false;
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.page {
  width: 100%;
  min-height: 100vh;
  padding: 100px 0 30px 0;
  background: #fefeff;
  .productList {
    padding: 0 40px;
  }
}
.page.padding {
  padding-top: 200px;
}
</style>
